export default "__VITE_ASSET__LngRfU6X__"